import type { CorvidSDKPropsFactory } from '@wix/editor-elements-types/corvid';
import { withValidation } from '../../validations';
import type { AriaAttributesSDKProps, AriaLabelSDK } from './types';
import { assert } from '../../assert';

const ariaLabelSDKFactory: CorvidSDKPropsFactory<
  AriaAttributesSDKProps,
  AriaLabelSDK
> = ({ setProps, props }) => ({
  get label() {
    return props.ariaAttributes?.label;
  },
  set label(value) {
    setProps({
      ariaAttributes: {
        ...props.ariaAttributes,
        label: assert.isNil(value) ? undefined : value,
      },
    });
  },
});

export const createAriaLabelSDK = withValidation(ariaLabelSDKFactory, {
  type: ['object'],
  properties: {
    label: {
      type: ['string'],
      minLength: 1,
      maxLength: 1000,
    },
  },
});
